<template>
    <v-app-bar
            absolute
            app
            class="header elevation-0"
            color="secondary">
        <div class="d-flex align-center">
            <v-img
                    :key="organizationLogo"
                    :src="organizationLogo"
                    class="shrink mr-2 pointer organization-logo"
                    contain
                    max-height="55"
                    transition="scale-transition"
                    width="100"
                    @click="$router.push({name: 'circleMap'})"
            />
        </div>
        <div class="font-weight-bold text-h5 organization-name">{{ organizationName }}</div>
        <v-spacer></v-spacer>
        <v-menu v-if="isAuthenticated"
                ref="menu"
                :open-on-hover="!subMenu"
                offset-y
                @input="menuStatus">
            <template v-slot:activator="{ on, attrs, value }">
                <div :class="{'avatar-padding': subMenu, 'pl-16': value && !subMenu}" v-bind="attrs"
                     v-on="on">
                    <v-avatar>
                        <img
                                v-if="avatar"
                                :src="avatar"
                                alt="avatar">
                        <v-icon v-else size="50">
                            mdi-account-circle
                        </v-icon>
                    </v-avatar>
                </div>
            </template>
            <v-list class="px-2" tile>
                <v-list-item
                        v-for="(item, index) in itemsFistPart"
                        :key="index"
                        :class="{'v-list-item--active': $route.name === item.routeName || item.routeName.includes($route.name)}"
                        link
                        @click="item.action">
                    <v-list-item-icon>
                        <img :src="item.icon" alt="icon" class="filter-to-inverse-theme"/>
                    </v-list-item-icon>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-for="(item, index) in itemsSecondPart"
                        :key="index+'sec'"
                        :class="{'v-list-item--active': $route.name === item.routeName}"
                        link
                        @click="item.action">
                    <v-list-item-icon>
                        <img :src="item.icon" alt="icon" class="filter-to-inverse-theme"/>
                    </v-list-item-icon>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      subMenu: false,
      menu: false,
    };
  },
  computed: {
    organizationLogo() {
      return this.organization && this.organization.LogoUrl ? this.organization.LogoUrl + '?t=' + new Date().getTime() : require('@/assets/logo.png');
    },
    organizationName() {
      return this.$store.getters.getOrganizationName;
    },
    avatar() {
      let avatar = this.$store.getters.getAvatar;
      if (avatar) {
        avatar += '?t=' + new Date().getTime();
      }

      return avatar;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    itemsFistPart() {
      let items = [{
        title: this.$t('menu.account'),
        icon: require('@/assets/icons/person.svg'),
        action: this.myProfile,
        routeName: 'myAccount',
        id: 'account'
      }];
      if (this.$store.getters.isOrganizationAdmin && !this.organization.IsSubscriptionExpired && this.hasActiveOrganization) {
        items.push({
          title: this.$t('menu.settings'),
          icon: require('@/assets/icons/settings.svg'),
          action: this.openSettings,
          routeName: ['subscriptionSettings', 'notificationsAndAlerts'],
          id: 'settings'
        });
      }

      if (this.$store.getters.getOrganizations.length) {
        items.push({
          title: this.$t('account.subscriptions'),
          icon: require('@/assets/icons/payments.svg'),
          action: this.openSubscriptions,
          routeName: 'subscriptions',
          id: 'settings'
        });
      }

      return items;
    },
    itemsSecondPart() {
      return [
        /*{
          title: this.$t('menu.openTour'),
          icon: require('@/assets/icons/open-tour.svg'),
          action: this.openTour,
          id: 'openTour'
        },*/
        {title: this.$t('menu.logout'), icon: require('@/assets/icons/logout.svg'), action: this.logout, id: 'logout'},
      ];
    },
    organizations() {
      return this.$store.getters.getOrganizations;
    },
    selectedOrganization() {
      return this.$store.getters.getOrganizationId;
    },
    organization() {
      return this.$store.getters.selectedOrganization;
    },
    hasActiveOrganization() {
      return this.$store.getters.hasActiveOrganization;
    },
  },
  methods: {
    myProfile() {
      this.$router.push({name: 'myAccount'});
    },
    openSettings() {
      this.$router.push({name: 'subscriptionSettings'});
    },
    openSubscriptions() {
      this.$router.push({name: 'subscriptions'});
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({name: 'login'});
      });
    },
    selectOrganization(id) {
      this.$refs.subscriptions.click();
      this.$store.dispatch('setOrganizationId', id).then(() => {
        if (!this.$store.getters.selectedOrganization.IsSubscriptionExpired) {
          this.$router.push({name: 'circleMap'});
        }
      });
    },
    subMenuStatus(status) {
      this.subMenu = status;
    },
    menuStatus(status) {
      this.menu = status;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "header";
</style>